export default __webpack_public_path__ + "static/media/SideShape.a404c40c.svg";